import * as React from 'react';

import RetrievalContext from 'data-lake/preview/contexts/RetrievalContext';
import { INTERNAL_DATA_LAKE_TYPE } from 'data-lake/Constants';
import type { SelectableLogViewMessage } from 'logview/types';

const bulkRetrievePayload = (
  messages: SelectableLogViewMessage[],
  dataLakeId: string,
  payload: { sourceId: string },
) => ({
  messages,
  data_lake_id: dataLakeId,
  type: INTERNAL_DATA_LAKE_TYPE,
  stream_id: payload.sourceId,
  timeout: undefined,
});

const RetrievalProvider = ({ children }: React.PropsWithChildren) => {
  const contextValue = React.useMemo(() => ({ bulkRetrievePayload }), []);

  return <RetrievalContext.Provider value={contextValue}>{children}</RetrievalContext.Provider>;
};

export default RetrievalProvider;
